module.exports = __webpack_public_path__ + "img/fire-icon.af02ba66.svg";